const animeConfig = {
  onePiece: {
    backgroundMusic: '/audio/game-song-background.mp3',
    incorrectSound: '/audio/incorrect-yasashi.mp3',
    gameOverSound: '/audio/game-over-show.mp3',
    correctAnswerSound: '/audio/correct-ans.mp3',
    introImage: '/GAME START.jpg',
    gameOverBackground: '/game-over-background.jpg',
    backgroundImage: require('../assets/images/seaonepiece.jpg'),
  },
};

export default animeConfig;
